import {
  markAlertAsRead,
  selectAlertsByHierarchy,
  useAppDispatch,
  useAppSelector,
} from '@/store'
import { Alert } from '@/types/alerts'
import { useMemo } from 'react'

export const useTabAlerts = (
  itemName: string,
  // TODO: dont make this hardcoded
  clarityLensType: string = 'Sales Lens',
  tabNames: string[] = [
    'Overview',
    'Sales',
    'Bought Together',
    'Profitability',
    'Discounts',
    'Payment Type',
  ]
) => {
  const dispatch = useAppDispatch()

  // Get all alerts for this item once
  const itemAlerts = useAppSelector(
    selectAlertsByHierarchy({
      clarityLens: clarityLensType,
      item: itemName,
    })
  )

  const tabAlertStatus = useMemo(() => {
    return tabNames.reduce(
      (acc, tabName) => {
        // Filter alerts for this specific tab
        const tabAlerts = itemAlerts.filter(
          (alert: Alert) => alert.hierarchy.tab === tabName
        )

        acc[tabName] = {
          hasUnread: tabAlerts.some((alert: Alert) => !alert.isRead),
          unreadCount: tabAlerts.filter((alert: Alert) => !alert.isRead).length,
          alerts: tabAlerts,
        }

        return acc
      },
      {} as Record<
        string,
        { hasUnread: boolean; unreadCount: number; alerts: Alert[] }
      >
    )
  }, [itemAlerts, tabNames])

  const markTabAlertsAsRead = (tabName: string) => {
    const tabAlerts = tabAlertStatus[tabName]?.alerts || []
    tabAlerts.forEach((alert: Alert) => {
      if (!alert.isRead) {
        dispatch(markAlertAsRead(alert.id))
      }
    })
  }

  return {
    tabAlertStatus,
    markTabAlertsAsRead,
  }
}
